// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import AnalyticsListener from "./analytics/AnalyticsListener";

// Layout
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Pages principales
import Galerie from "./pages/Galerie";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AccesClients from "./pages/AccesClients";

// Pages légales
import MentionsLegales from "./pages/MentionsLegales";
import CGV from "./pages/CGV";
import Confidentialite from "./pages/Confidentialite";

// Styles globaux
import "./index.css";

export default function App() {
  return (
    <Router>
      {/* Google Analytics / GA4 */}
      <AnalyticsListener />

      <div className="app-shell">
        <Navbar />

        <main role="main">
          <Routes>
            {/* Accueil → galerie */}
            <Route path="/" element={<Navigate to="/galerie" replace />} />

            {/* Pages publiques */}
            <Route path="/galerie" element={<Galerie />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            {/* Accès clients */}
            <Route path="/acces-clients" element={<AccesClients />} />

            {/* Pages légales */}
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/cgv" element={<CGV />} />
            <Route path="/confidentialite" element={<Confidentialite />} />

            {/* 404 → redirection */}
            <Route path="*" element={<Navigate to="/galerie" replace />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}